import {
    Alert,
    Box,
    Button,
    Divider,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import { DrawRounded } from '@mui/icons-material';

export function SignStep({ contract }) {
    const integrationId = contract?.integrationId;
    const signedAt = contract?.signedAt;
    const isSigned = Boolean(signedAt);
    const hasPendingSignature = Boolean(integrationId) && !isSigned;

    const signedDate = signedAt
        ? new Date(signedAt).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
          })
        : null;

    return (
        <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <DrawRounded color="action" />
                    <Typography variant="h3" component="h2">
                        Assinatura do contrato
                    </Typography>
                </Stack>

                <Divider />

                {!integrationId && (
                    <Alert severity="info">
                        Aguardando geração do contrato pelo administrador.
                    </Alert>
                )}

                {hasPendingSignature && (
                    <Stack spacing={1}>
                        <Alert severity="warning">
                            Contrato gerado e enviado para assinatura. Verifique seu e-mail para assinar.
                        </Alert>
                        <Typography variant="body2" color="text.secondary">
                            Após assinar o documento, os próximos passos ficarão disponíveis automaticamente.
                        </Typography>
                        {contract?.contractData?.documentUrl && (
                            <Box>
                                <Button
                                    variant="outlined"
                                    href={contract.contractData.documentUrl}
                                    target="_blank"
                                    rel="noopener"
                                >
                                    Abrir contrato
                                </Button>
                            </Box>
                        )}
                    </Stack>
                )}

                {isSigned && (
                    <Alert severity="success">
                        Contrato assinado em {signedDate}.
                    </Alert>
                )}
            </Stack>
        </Paper>
    );
}
